import * as React from 'react'
import { SERVICE_ALL } from '../domain/Service'

interface Props {
    service: string
    environment: string
}

class ServiceEnvironmentIndicator extends React.Component<Props> {
    public render = () => {
        return (
            <>
                {this.props.service === SERVICE_ALL ? (
                    <span className={'text-muted'}>
                        Service <strong>Overview</strong>
                    </span>
                ) : (
                    <span className={'text-muted'}>
                        Service: <strong>{this.props.service}</strong>
                    </span>
                )}

                {this.props.environment !== 'production' ? (
                    <span className={'text-muted'}>
                        {' '}
                        &middot; Environment: <strong>{this.props.environment}</strong>
                    </span>
                ) : null}
            </>
        )
    }
}

export default ServiceEnvironmentIndicator
